import { Dialog } from "@headlessui/react";
import { ModalFoterBox } from "../box/Box";
import Button from "../button/Button";
import { Modal, ModalProp } from "./Modal";

export type ConfirmModalProps = {
  handle: () => Promise<void>;
  contentType: string;
  title?: any;
  body?: any;
}

export const ConfirmModal = ({
  open,
  toggle,
  closeOnClickOutside,
  handle,
  contentType,
  title,
  body,
}: ModalProp & ConfirmModalProps) => {

  const executionButton = () => {
    switch(contentType){
      case 'regist':
        return (
          <Button
            className="mt-1 mr-2 w-[132px]"
            onClick={(e) => {
              handle();
              toggle(true);
            }}
            children={"登録"}
          />
        );
      case 'delete':
        return (
          <Button
            className="mt-1 mr-2 w-[132px]"
            color="red"
            onClick={(e) => {
              handle();
              toggle(true);
            }}
            children={"削除"}
          />
        );
      default:
        return (<></>);
    };
  };

  return (
    <>
      <Modal
        open={open}
        toggle={toggle}
        closeOnClickOutside={closeOnClickOutside}
      >
        <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all">
          <div className="px-2 pb-4 sm:p-4">
            <Dialog.Title
              as="h3"
              className="text-left text-lg font-medium leading-6 text-gray-900 mb-2"
            >
              {title ? (
                <>{title}</>
              ) : (
                <></>
              )}
            </Dialog.Title>
            {body ? (
              <>{body}</>
            ) : (
              <></>
            )}
          </div>
          <ModalFoterBox>
            <Button
              className="mx-2 mt-1 w-[132px]"
              outline
              onClick={toggle}
              children={"キャンセル"}
            />
            {executionButton()}
          </ModalFoterBox>
        </Dialog.Panel>
      </Modal>
    </>
  );
};